var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"home-products-section flex gap-4 flex-col-reverse md:flex-row"},[_c('Filters',{staticClass:"filters-section md:1/4 lg:w-1/5"}),_c('div',{staticClass:"sub-route-container md:w-3/4 lg:w-4/5"},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }